export const staging_URL = "https://stage.app.medlucy.com/api";
// export const BASE_URL = "https://release.app.medlucy.com/api";
export const productionURL = 'https://app.medlucy.com/api';
export const BASE_URL = 'https://app.medlucy.com/api';
export const AGENDA_HEADERS = {
  headers: {
    "Content-Type": "application/json",
    'accept': 'application/json'
  },
};
